import style from "./00_tcp.css"
import Header from '../components/header'
import Footer from '../components/footer'
export default function PrivacyPolicies() {
    return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
      <Header />
        <div class="legal-document">
          <h1>Privacy Policy</h1>
          <p><strong>Last Updated:</strong>  13th August 2026</p>

          <p><strong>Sursaathi</strong> ("we", "us", "our") respects your privacy. This Privacy Policy explains how we collect, use, share, and retain information when you use <strong>sursaathi.in</strong> (the "Website").</p>

          <h2>1. Information We Collect</h2>

          <h3>Contact Information</h3>
          <p>When you contact us, we may collect your name, email address, phone number, location, the contents of your message, and other information you voluntarily provide.</p>

          <h3>Instrument Information</h3>
          <p>If you submit an instrument through our Website, we may collect your name and contact details, instrument type, make, model, age, condition, photographs of the instrument, information about ownership or donation, and other information you voluntarily provide.</p>

          <h3>Music Teacher Information</h3>
          <p>If you register as a music teacher, we may collect your name, contact details, location, instruments or subjects taught, teaching experience, qualifications or other professional information, availability, profile photographs, and other information relevant to creating a teacher listing.</p>

          <p>Some teacher information may be displayed publicly on the Website so that students can find suitable teachers.</p>

          <h3>Student Information</h3>
          <p>When a student or other user submits a request for information about a teacher, we may collect their name, contact details, location, teacher preferences, instrument or subject of interest, information contained in the request, and other information voluntarily provided.</p>

          <h2>2. How We Use Information</h2>
          <p>We may use information we collect to:</p>
          <ul>
            <li>Provide and operate our Website;</li>
            <li>Respond to enquiries;</li>
            <li>Process instrument submissions or donation enquiries;</li>
            <li>Create and manage music teacher listings;</li>
            <li>Help students find appropriate teachers;</li>
            <li>Facilitate communication between students and teachers;</li>
            <li>Share relevant student information with a teacher when the student requests information about that teacher;</li>
            <li>Share relevant teacher information with a student when the student requests that information;</li>
            <li>Communicate with users about their submissions;</li>
            <li>Maintain and improve the Website;</li>
            <li>Prevent fraud, misuse, spam, or security problems; and</li>
            <li>Comply with applicable legal obligations.</li>
          </ul>

          <h2>3. Public Teacher Listings</h2>
          <p>Music teachers who register may have certain information displayed publicly, such as their name, teaching subjects or instruments, general location, experience or qualifications, profile information, and other information provided for the purpose of creating a public listing.</p>

          <p>Teachers should not submit private information that they do not want displayed publicly.</p>

          <h2>4. Sharing Information Between Students and Teachers</h2>
          <p>One of the purposes of our Website is to facilitate connections between music teachers and students.</p>

          <p>When a student submits a request for information about a particular teacher, we may provide the teacher with relevant information submitted by the student so that the teacher can respond.</p>

          <p>We may also provide the student with relevant information about the teacher.</p>

          <p>This may include names, contact details, location, musical interests, and other information relevant to facilitating the requested connection.</p>

          <h2>5. Instrument Photographs</h2>
          <p>If you submit a photograph of an instrument, we may store and use the photograph for the purpose for which it was submitted, including evaluating, identifying, documenting, displaying, or facilitating a donation or instrument-related enquiry.</p>

          <p>Please do not upload photographs containing unnecessary personal information, identification documents, financial information, or other sensitive information.</p>

          <h2>6. Information We Do Not Intentionally Collect</h2>
          <p>We do not intentionally request highly sensitive personal information through our ordinary forms.</p>

          <p>Please do not submit passwords, financial account credentials, government identification numbers, medical information, or other sensitive information unless we specifically request it for a lawful and stated purpose.</p>

          <h2>7. Cookies and Technical Information</h2>
          <p>Our Website and third-party services used by the Website may automatically collect certain technical information, such as IP address, browser type, device type, operating system, pages visited, approximate usage information, and date and time of access.</p>

          <p>We may use cookies and similar technologies to operate, secure, analyse, and improve the Website.</p>

          <h2>8. Service Providers</h2>
          <p>We may use trusted third-party service providers to help operate the Website, such as providers of website hosting, forms, email, database or cloud storage, analytics, security, and other website functionality.</p>

          <p>These providers may process information as reasonably necessary to provide their services.</p>

          <h2>9. Legal and Security Disclosures</h2>
          <p>We may disclose information where we reasonably believe disclosure is necessary to comply with applicable law, respond to lawful requests, protect our rights or property, protect users or the public, investigate fraud or security issues, or enforce our Terms and Conditions.</p>

          <h2>10. Data Retention</h2>
          <p>We retain information for as long as reasonably necessary for the purposes described in this Privacy Policy.</p>

          <p>If you request deletion of your account or information, we will aim to process the request within <strong>7 days</strong>.</p>

          <p>Deletion from the Website does not necessarily mean that all information is immediately and permanently erased from our systems.</p>

          <p>We may retain certain information after deletion where necessary for legal, regulatory, accounting, security, fraud-prevention, dispute-resolution, record-keeping, or other legitimate purposes.</p>

          <p>Information retained after deletion will <strong>not be publicly displayed</strong> and will not ordinarily be shared for the normal operation of the Website.</p>

          <p>Backup copies may also remain for a limited period before being overwritten or securely deleted in accordance with our normal backup processes.</p>

          <h2>11. Account and Data Deletion</h2>
          <p>If you have an account or have submitted information to us, you may request deletion by following the instructions in our <strong>Account and Data Deletion Policy</strong>.</p>

          <p>We may need to verify your identity or ownership of the relevant information before processing a deletion request.</p>

          <h2>12. Children's Privacy</h2>
          <p>Our Website may be used to help students find music teachers. Where students are minors, parents or legal guardians should be involved in the use of the Website and any communication or arrangement with teachers.</p>

          <p>We do not knowingly seek unnecessary personal information from children.</p>

          <h2>13. Data Security</h2>
          <p>We take reasonable measures to protect information against unauthorised access, loss, misuse, alteration, or disclosure.</p>

          <p>However, no method of transmission or electronic storage is completely secure, and we cannot guarantee absolute security.</p>

          <h2>14. Your Privacy Rights</h2>
          <p>Depending on your location and applicable law, you may have rights relating to your personal information, including the right to request access, correction, deletion, or information about how your information is used or shared.</p>

          <p>To exercise an applicable right, contact us using the details below.</p>

          <h2>15. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. The "Last Updated" date at the top of this document indicates when it was most recently revised.</p>

          <h2>16. Contact Us</h2>
          <p>
            <strong>SurSaathi</strong><br />
            Privacy Contact: sursaathi.music@gmail.com<br />
            General Contact: sursaathi.music@gmail.com<br />
            Website: sursaathi.in<br />
          </p>
        </div>

      <Footer />
    </div>
  );
}